// ─── DATOS DE LA EMPRESA ─────────────────────────────────────────────────────
// Todo lo que identifica a la empresa en pantalla, PDFs y Excel sale de aquí.
// Para poner el logo: sube el archivo a frontend/public/assets/ y escribe la ruta
// en "logo" (pantalla, PNG) y "logoPdf" (PDF, JPG). Mientras estén en null se usa
// el nombre en texto.
export const EMPRESA = {
  nombre: "StarWest",
  razonSocial: "StarWest",
  lema: "",
  logo: "/assets/starwest-logo.png", // pantalla (fondo negro, PNG transparente)
  logoHorizontal: "/assets/starwest-logo-horizontal.png", // encabezados chicos (fondo negro)
  logoPdf: "/assets/starwest-logo-pdf.jpg", // PDFs (JPG, proporción 2.75:1)
  prefijoOC: "SW", // debe coincidir con PREFIJO_OC del backend
};

// Carga el logo para PDF como dataURL; si no hay logo configurado lanza error
// y el PDF usa el nombre en texto.
export const cargarLogoPdf = async () => {
  if (!EMPRESA.logoPdf) throw new Error("sin logo");
  const res = await fetch(EMPRESA.logoPdf);
  if (!res.ok || !(res.headers.get("content-type") || "").startsWith("image/")) throw new Error("sin logo");
  const blob = await res.blob();
  return await new Promise((r) => {
    const fr = new FileReader();
    fr.onload = () => r(fr.result);
    fr.readAsDataURL(blob);
  });
};
